import React from 'react'
import { withStyles } from '@material-ui/core/styles'
// import '@progress/kendo-ui'
import { InsertTextTool } from './insertTools'
import ConnectedColorPickerTool from './ColorPickerTool.js'

import { Editor, EditorTools } from '@progress/kendo-react-editor'
const {
	Bold,
	Italic,
	Underline,
	Strikethrough,
	Subscript,
	Superscript,
	AlignLeft,
	AlignCenter,
	AlignRight,
	AlignJustify,
	Indent,
	Outdent,
	OrderedList,
	UnorderedList,
	Undo,
	Redo,
	FontSize,
	FontName,
	FormatBlock,
	Link,
	Unlink,
	InsertImage,
	// ViewHtml,

	// InsertTable,
	// AddRowBefore,
	// AddRowAfter,
	// AddColumnBefore,
	// AddColumnAfter,
	// DeleteRow,
	// DeleteColumn,
	// DeleteTable,
	// MergeCells,
	// SplitCell,
} = EditorTools

const styles = (theme) => ({
	root: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
	},
})

const KendoEditor = ({ onChange, value, contentHeight, noMergeFields }) => {
	// const getUrl = window.location
	// const baseUrl = getUrl.protocol + '//' + getUrl.host
	const initialTools = [
		Bold,
		Italic,
		Underline,
		Strikethrough,
		Subscript,
		Superscript,
		AlignLeft,
		AlignCenter,
		AlignRight,
		AlignJustify,
		Indent,
		Outdent,
		OrderedList,
		UnorderedList,		
		ConnectedColorPickerTool,
		Undo,
		Redo,
		Link,
		Unlink,
		InsertImage /*, ViewHtml */,
		FontSize,
		FontName,
		FormatBlock,
		// InsertTable,
		// AddRowBefore,
		// AddRowAfter,
		// AddColumnBefore,
		// AddColumnAfter,
		// DeleteRow,
		// DeleteColumn,
		// DeleteTable,
		// MergeCells,
		// SplitCell,
	]

	const tools = noMergeFields ? initialTools : [...initialTools, InsertTextTool]

	return (
		<>
			<Editor
				onChange={(e) => onChange(e.html)}
				// onChange={(e) => console.log(e)}
				value={value}
				// defaultContent={value}
				// encoded={false}
				// stylesheets={[baseUrl + '/reset.css']}
				// resizable={{
				//   toolbar: true,
				//   /* , content: true */
				// }}
				contentStyle={{
					height: contentHeight || 550,
					borderRadius: 8,
				}}
				tools={tools}
			/>
		</>
	)
}

export default withStyles(styles)(KendoEditor)
